import { TypographyV3 } from '@jouzen/ecom-components';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';
import { type ComponentPropsWithoutRef, forwardRef } from 'react';

import type { PopHighlightsFeatureData } from '@/app/[locale]/product/rings/oura-gen3/_components/PopHighlights/data/popHighlightsFeatures';

export type PopHighlightsFeatureProps = ComponentPropsWithoutRef<'div'> &
  Omit<PopHighlightsFeatureData, 'id'>;

export const PopHighlightsFeature = forwardRef<
  HTMLDivElement,
  PopHighlightsFeatureProps
>(function PopHighlightsFeature(
  {
    bullets,
    className,
    description,
    Icon,
    title,
    ...props
  }: PopHighlightsFeatureProps,
  ref,
): JSX.Element {
  const t = useTranslations();

  return (
    <div
      className={cx(className, 'rounded-lg bg-sandstone-200')}
      data-cy="pop_highlights_feature"
      ref={ref}
      {...props}
    >
      <div className="p-6">
        <div className="mb-4 flex items-center">
          <Icon className="mr-4 lg:hidden" height={28} width={28} />
          <TypographyV3 Element="h3" variant="h6">
            {t(title)}
          </TypographyV3>
        </div>
        <TypographyV3>{t(description)}</TypographyV3>
        {bullets && (
          <TypographyV3
            className="mt-4 list-disc pl-5 opacity-75"
            Element="ul"
            variant="body-small"
          >
            {t.rich(bullets)}
          </TypographyV3>
        )}
      </div>
    </div>
  );
});
